import { RozmerPneuDisku } from '@/modules/ciselnik/pneu/rozmerPneuDisku';
import { SirkaDisku } from '@/modules/ciselnik/pneu/sirkaDisku';
import { SirkaPneu } from '@/modules/ciselnik/pneu/sirkaPneu';
import { SkladPneu } from '@/modules/ciselnik/pneu/skladPneu';
import { SkladoveMistoPneu } from '@/modules/ciselnik/pneu/skladoveMistoPneu';
import { TypPneu } from '@/modules/ciselnik/pneu/typPneu';
import { VyrobcePneu } from '@/modules/ciselnik/pneu/vyrobcePneu';
import { VyrobceDisku } from '@/modules/ciselnik/pneu/vyrobceDisku';
import { VyskaPneu } from '@/modules/ciselnik/pneu/vyskaPneu';

export const menu = {
	name: 'pPneuCis',
	list: [
		{ name: 'pPDRozmer', route: RozmerPneuDisku.name },
		{ name: 'pDisksirka', route: SirkaDisku.name },
		{ name: 'pPneusirka', route: SirkaPneu.name },
		{ name: 'pSkladpneu', route: SkladPneu.name },
		{ name: 'pSkladmistoP', route: SkladoveMistoPneu.name },
		{ name: 'pTypPneu', route: TypPneu.name },
		{ name: 'pVyrobekpneu', route: VyrobcePneu.name },
		{ name: 'pVyrobekdisk', route: VyrobceDisku.name },
		{ name: 'pPneuvyska', route: VyskaPneu.name },
	],
};
